import { createAction } from '../../utils/redux/createAction';
import {
  calculateNextWeek,
  calculatePrevWeek,
  setNewDate,
  getInitDateState,
} from '../../utils/schedule/date-formatter';
import { SCHEDULE_VALIDATE_TYPES } from './validate';

const actionsScope = 'schedule/filter';

export const SCHEDULE_FILTER_TYPES = {
  NEXT_WEEK: `${actionsScope}/next-week`,
  PREV_WEEK: `${actionsScope}/prev-week`,
  SET_DATE: `${actionsScope}/set-date`,
  RESET: `${actionsScope}/reset`,
};

export const scheduleFilterActions = {
  nextWeek: createAction(SCHEDULE_FILTER_TYPES.NEXT_WEEK),
  prevWeek: createAction(SCHEDULE_FILTER_TYPES.PREV_WEEK),
  setDate: createAction(SCHEDULE_FILTER_TYPES.SET_DATE),
  reset: createAction(SCHEDULE_FILTER_TYPES.RESET),
};

const initialState = {
  ...getInitDateState(),
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SCHEDULE_FILTER_TYPES.PREV_WEEK: {
      return { ...state, ...calculatePrevWeek(state.startOn) };
    }
    case SCHEDULE_FILTER_TYPES.NEXT_WEEK: {
      return { ...state, ...calculateNextWeek(state.startOn) };
    }
    case SCHEDULE_FILTER_TYPES.SET_DATE: {
      return { ...state, ...getInitDateState(payload) };
    }

    case SCHEDULE_VALIDATE_TYPES.CLEAR:
    case scheduleFilterActions.RESET: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/schedule/filter.js